import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import Rating from '@/components/base/Rating';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  const typeLabel = movie.type === 'movie' ? '电影' : '电视剧';

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 font-label text-xs text-background-50">
          {typeLabel}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center rounded-md bg-background-50/90 px-2 py-0.5 backdrop-blur-sm">
          <Rating value={movie.rating} />
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-accent-600">
          {movie.title}
        </h3>
        <p className="mt-1 truncate font-label text-xs text-foreground-600">
          {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(' / ')}
        </p>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {movie.summary}
        </p>
      </div>
    </Link>
  );
}